import SettingsSchlage from "./SettingsSchlage";
import React, { useEffect, useContext } from "react";
// import PropTypes from 'prop-types';
import { useFetchDoors, useFetchHotel, useSetCurrentUser } from "./redux/hooks";
import { Box, Heading, Button, ResponsiveContext } from "grommet";
import { Download } from "grommet-icons";
import { SettingsDoorTable } from "./";
import { PmsService } from "../../services";
import { presentLoading, dismissLoading } from "@shared/Loading";
import "./SettingsRoomsAreas.scss";
import { pmsThatCanImportDoors } from "@common/features";
import { useTranslation } from "react-i18next";
export default function SettingsRoomsAreas() {
  const { t } = useTranslation();
  const { rooms, areas, fetchDoors } = useFetchDoors();
  const { hotel } = useFetchHotel();
  const { currentUser } = useSetCurrentUser(null);
  const contextSize = useContext(ResponsiveContext);
  const isSmall = contextSize === "small";

  useEffect(() => {
    fetchDoors();
  }, [fetchDoors]);

  const handleImport = () => {
    presentLoading();
    PmsService.importDoors().then(
      (response) => {
        fetchDoors();
        dismissLoading();
      },
      (error) => {
        dismissLoading();
      },
    );
  };

  return (
    <div className="doorTablesContainer">
      <Box direction="row" justify="between">
        <Heading level="2">{t("settingsRoomsAreas.title")}</Heading>
        {pmsThatCanImportDoors.includes(hotel.pmsSlug) && (
          <Button
            style={{ maxHeight: 30 }}
            alignSelf="center"
            icon={<Download size="small" />}
            label={t("settingsRoomTypes.importFromPms")}
            primary
            color="status-warning"
            onClick={handleImport}
          />
        )}
      </Box>
      <SettingsSchlage
        hotel={hotel}
        role={currentUser?.role}
        onMapped={fetchDoors}
      />
      <Box direction={isSmall ? "column" : "row"} gap="large">
        <SettingsDoorTable
          title={t("settingsRoomsAreas.rooms")}
          type="room"
          doors={[...rooms, ...areas]}
          onRefresh={fetchDoors}
        />
        {hotel.serviceType !== "messaging" && (
          <SettingsDoorTable
            title={t("settingsRoomsAreas.areas")}
            type="area"
            doors={[...rooms, ...areas]}
            onRefresh={fetchDoors}
          />
        )}
      </Box>
    </div>
  );
}

SettingsRoomsAreas.propTypes = {};
SettingsRoomsAreas.defaultProps = {};
